import { useState, useCallback, createContext, useContext } from 'react';

const ConfirmContext = createContext();

export const useConfirm = () => useContext(ConfirmContext);

export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, message: '', resolve: null });

  const confirm = useCallback((message) => {
    return new Promise((resolve) => {
      setState({ open: true, message, resolve });
    });
  }, []);

  const handleYes = () => {
    state.resolve?.(true);
    setState({ open: false, message: '', resolve: null });
  };

  const handleNo = () => {
    state.resolve?.(false);
    setState({ open: false, message: '', resolve: null });
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {state.open && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 overflow-y-auto" data-testid="confirm-dialog">
          <div className="bg-slate-800 border border-slate-600 rounded-xl p-6 max-w-md w-full shadow-2xl my-auto max-h-[calc(100vh-2rem)] overflow-y-auto">
            <p className="text-white text-base mb-6">{state.message}</p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={handleNo}
                className="px-5 py-2 rounded-lg bg-slate-700 text-slate-300 hover:bg-slate-600 transition-colors text-sm font-medium"
                data-testid="confirm-no"
              >
                Cancelar
              </button>
              <button
                onClick={handleYes}
                className="px-5 py-2 rounded-lg bg-red-600 text-white hover:bg-red-500 transition-colors text-sm font-medium"
                data-testid="confirm-yes"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};
